/**
 * Překlad neúspěšné odpovědi do věty, která něco říká člověku u pultu.
 *
 * Vzniklo z 429 na závěru směny: kolega dostal na displej „HTTP 429", což
 * nesděluje ani co se stalo, ani co má dělat — tak mačkal dál. Dvanáctkrát.
 * Limit na serveru je teď na člověka (viz `RateLimitServiceProvider`), ale
 * narazit na něj jde pořád a tehdy musí obrazovka říct dvě věci: že to není
 * jeho chyba, a za jak dlouho to půjde znovu.
 */

/** Když `Retry-After` chybí nebo je nesmyslné, radši počkat minutu. */
const VYCHOZI_CEKANI_S = 60;

export function sekundDoDalsihoPokusu(res) {
    const raw = Number(res?.headers?.get?.('Retry-After'));
    return Number.isFinite(raw) && raw > 0 ? Math.ceil(raw) : VYCHOZI_CEKANI_S;
}

/** „45 s" / „2 min" — pod minutu sekundy, nad ni zaokrouhlené minuty. */
export function formatCekani(sekundy) {
    if (sekundy < 60) return `${sekundy} s`;
    return `${Math.ceil(sekundy / 60)} min`;
}

/**
 * `data` = už rozparsované tělo odpovědi (může být prázdné).
 * Laravel u 429 posílá anglické „Too Many Attempts.", takže ho nepoužíváme.
 */
export function chybaZOdpovedi(res, data) {
    if (res?.status === 429) {
        return `Moc požadavků po sobě — zkus to znovu za ${formatCekani(sekundDoDalsihoPokusu(res))}.`;
    }
    return data?.error || `Nepovedlo se (chyba ${res?.status ?? '?'}).`;
}
